var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C16.1046 8 17 7.10457 17 6C17.5523 6 18 6.44772 18 7V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V7C6 6.44772 6.44772 6 7 6C7 7.10457 7.89543 8 9 8H15ZM7.17071 4C7.58254 2.83481 8.69378 2 10 2H14C15.3062 2 16.4175 2.83481 16.8293 4H17C18.6569 4 20 5.34315 20 7V19C20 20.6569 18.6569 22 17 22H7C5.34314 22 4 20.6569 4 19V7C4 5.34315 5.34314 4 7 4H7.17071ZM9 6H10H11H13H14H15V5C15 4.44772 14.5523 4 14 4H10C9.44772 4 9 4.44772 9 5V6ZM14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071L13.4142 14L14.7071 15.2929C15.0976 15.6834 15.0976 16.3166 14.7071 16.7071C14.3166 17.0976 13.6834 17.0976 13.2929 16.7071L12 15.4142L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929L10.5858 14L9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929C9.68342 10.9024 10.3166 10.9024 10.7071 11.2929L12 12.5858L13.2929 11.2929C13.6834 10.9024 14.3166 10.9024 14.7071 11.2929Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.1c331d3c56a8bbf7a910624c29614fe3.svg";
export { ForwardRef as ReactComponent };